/* eslint-disable no-use-before-define */
/* eslint-disable no-return-assign */
/* eslint-disable class-methods-use-this */
import classnames from "classnames";
import { withFormsy } from "formsy-react";
import { useEffect, useState } from "react";
import HideIf from "util/HideIf";
import floatingLabelStyles from "./floating_label.module.scss";
import ComponentDecorator from "./hoc/ComponentDecorator";
import styles from "./input.module.scss";
import propUtilities from "./prop-utilities";
import Row from "./row";

function Input(props) {
  const {
    type = "text", addonBefore = null, addonAfter = null, buttonBefore = null, buttonAfter = null, floatingLabel = false,
  } = props;
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (props.value) {
      setIsActive(true);
    }
  }, [props.value]);

  useEffect(() => {
    if (!props.isTouched && props.value) {
      props.setTouched(true);
    }
  }, [props.value, props.isTouched]);

  function changeValue(event: any) {
    const prevValue = props.value;
    let { value } = event.currentTarget;
    if (props.format) value = props.format(value);
    props.setValue(value);
    if (prevValue !== value) { props.setTouched(true); }
    props.onChange(props.name, value);
  }

  let element = renderElement();

  function handleBlur(e: any) {
    props.setTouched(true);

    if (e.target.value === "") {
      setIsActive(false);
    }
  }

  function renderElement() {
    let className = "form-control";
    if (["range"].indexOf(type) !== -1) {
      className = null;
    }
    return (
      <div className={styles.input_container}>
        <input
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
          ref={(c) => element = c}
          className={className}
          {...propUtilities.cleanProps(props)}
          id={props.getId()}
          value={props.value}
          onChange={changeValue}
          onBlur={handleBlur}
          disabled={props.isFormDisabled || props.disabled}
          onFocus={() => setIsActive(true)}
          placeholder={!floatingLabel ? props.placeholder : ""}
        />
        <HideIf show={floatingLabel}>
          <label htmlFor={props.getId()} className={`${floatingLabelStyles.floating_label} ${isActive ? floatingLabelStyles.floating_label_shrink : ""}`}>
            {`${props.required ? "*" : ""}${isActive ? props.label : (props.placeholder || props.label)}`}
          </label>
        </HideIf>
      </div>
    );
  }

  function renderInputGroup(_element: any) {
    const { inputGroup = "" } = props;
    return (
      <div className={`input-group ${inputGroup}`}>
        {renderAddon(props.addonBefore)}
        {renderButton(props.buttonBefore)}
        {_element}
        {renderAddon(props.addonAfter)}
        {renderButton(props.buttonAfter)}
      </div>
    );
  }

  function renderAddon(addon: any) {
    if (!addon) {
      return false;
    }
    return (
      <span
        className={classnames({
          [styles.renderAddon]: (props.showErrors() && props.isTouched) || (props.isValid && props.isTouched),
        }, "input-group-addon")}
      >
        {addon}

      </span>
    );
  }

  function renderButton(button: any) {
    const { inputGroupBtnClass = "" } = props;
    if (!button) {
      return false;
    }
    return (
      <span className={`${inputGroupBtnClass} input-group-btn`}>{button}</span>
    );
  }

  if (type === "hidden") {
    return element;
  }

  if (addonBefore || addonAfter || buttonBefore || buttonAfter) {
    element = renderInputGroup(element);
  }

  if (props.getLayout() === "elementOnly") {
    return element;
  }

  const { formGroupClass = "" } = props;
  const { classNames = "" } = props;
  return (
    <Row
      {...props.getRowProperties()}
      htmlFor={props.getId()}
      formGroupClass={formGroupClass}
      classNames={classNames}
      hideRequiredSymbol={props.hideRequiredSymbol}
      floatingLabel={floatingLabel}
    >
      {element}
      {props.renderHelp()}
      {props.isTouched && props.renderErrorMessage()}
    </Row>
  );
}

export default withFormsy(ComponentDecorator(Input));
